import React from 'react'

const LeftContainer = () => (
  <div className="col-sm me-left-cont">
    <img
      alt="profile"
      className="me-profile"
      src={require('../../shared/icons/profile.png')}
    />
  </div>
)

export default LeftContainer
